import type { IdentityProvider } from '../Security.types'
import { IDENTITY_PROVIDERS } from '../consts'

export const isIdentityProvider = (value: string | undefined): value is IdentityProvider => {
  return value ? Object.keys(IDENTITY_PROVIDERS).includes(value as IdentityProvider) : false
}
